export default __webpack_public_path__ + "static/media/Game-play.1f581ed2.png";